import {useNuxtApp} from 'nuxt/app'
import type {FetchError} from 'ofetch'
import {defineStore} from 'pinia'
import {computed, ref} from 'vue'
import {$lara} from '@/utils/$larafetch'
import type {PageResource, PageResourceData} from "~/types/page"

export const usePageStore = defineStore('page', () => {
    const pageData = ref<PageResource | null>(null)
    const pageLoaded = ref(false)
    const pageDoesNotExist = ref(false)

    let requestGeneration = 0

    const baseRoute = computed(() => 'spa.website.pages')

    function storePageData(response: PageResource) {
        pageLoaded.value = true
        pageData.value = {...response}
        pageDoesNotExist.value = false
    }

    function handleRequestError(error: FetchError<any>) {
        pageLoaded.value = true
        if (error?.response?.status === 404) pageDoesNotExist.value = true
        return {error}
    }

    async function fetchPageData(sport: string | null, section: string | null, group: string | null, slug: string | null, selectedSeasons: Object | null) {
        const current = ++requestGeneration
        pageLoaded.value = false

        const response = await $lara.get<PageResourceData>(useNuxtApp().$apiRoute(baseRoute.value + '.show', {
            sport: sport,
            section: section,
            group: group,
            slug: slug,
            selectedSeasons: selectedSeasons,
        }))
        if (current !== requestGeneration) return
        return handleStoreResult(response, storePageData, handleRequestError)
    }

    function resetData() {
        requestGeneration++
        pageData.value = null
        pageLoaded.value = false
        pageDoesNotExist.value = false
    }

    return {
        pageData,
        pageLoaded,
        pageDoesNotExist,
        baseRoute,
        fetchPageData,
        resetData,
    }
})
